<template>
  <div class="dataTables_wrapper no-footer mtable">
    <!-- <div class="title-box"> -->
    <slot name="menu"></slot>
    <div class="datatable-header mtable-tool hui-group-dib-box">
      <seekDatePicker
        :seekDatePicker="seekDatePicker"
        @seekDatePicker="seekDatePickerFn"
        class="pull-left m-r-30 mtable-tool-seek"
        v-if="seekDatePicker"
      ></seekDatePicker>
      <seek
        :seekDropdown="seekDropdownProps"
        @clickSeekDropdown="clickSeekDropdown"
        @seek="seek"
        class="pull-left m-r-30 mtable-tool-seek"
        v-if="seekDropdown"
      ></seek>
      <selPage
        :multiLanguage="multiLanguage"
        :selPage="selPage"
        @selPage="selPageFn"
        class="pull-right"
        v-if="selPage"
      ></selPage>
      <div class="btn-group p-0 pull-left mtable-tool-fn">
        <slot name="return-back"></slot>
        <slot name="handle"></slot>
        <div class="commission-confirm" v-if="operate.checkbox">
          <el-button
            :disabled="checkedArr.length == 0"
            @click="updateStatus(3)"
            type="primary"
          >{{multiLanguage.confirm}}</el-button>
        </div>
        <div class="commission-confirm" v-if="operate.checkbox">
          <el-button
            :disabled="checkedArr.length == 0 || refuseReason.length == 0"
            @click="updateStatus(4)"
            type="primary"
          >{{multiLanguage.reject}}</el-button>
        </div>
        <div class="commission-confirm" v-if="operate.checkbox">
          <el-input
            :disabled="checkedArr.length == 0"
            :placeholder="multiLanguage.rejectMessage"
            autosize
            type="textarea"
            v-model="refuseReason"
          ></el-input>
        </div>
        <jsonExcel
          :ajaxGetKey="jsonExcelAjax.getKey"
          :ajaxPar="jsonExcelAjax.ajaxPar || false"
          :ajaxType="jsonExcelAjax.ajaxType"
          :ajaxUrl="jsonExcelAjax.url || false"
          :cID="jsonExcelAjax.cID"
          :downLoadTran="downLoadTran"
          :keys="thData"
          :name="name"
          :rID="jsonExcelAjax.rID"
          :type="jsonExcelAjax.type"
          class="btn btn-default"
          v-if="jsonExcelAjax"
        >
          <!-- :colData="Object.keys(totalTr).length > 0?[...jsonExcelAjax.colData, totalTr]:jsonExcelAjax.colData" -->
          <i class="glyphicon glyphicon-save tab-he-glyphicon"></i>
          {{multiLanguage.downloadExcelForms}}
        </jsonExcel>

        <jsonExcel
          :ajaxGetKey="detailExcelAjax.getKey"
          :ajaxPar="detailExcelAjax.ajaxPar || false"
          :ajaxType="detailExcelAjax.ajaxType"
          :ajaxUrl="detailExcelAjax.url || false"
          :downLoadTran="downLoadTran"
          :keys="detailTh"
          :name="detailName"
          :rID="detailExcelAjax.rID"
          class="btn btn-default"
          v-if="detailExcelAjax"
        >
          <i class="glyphicon glyphicon-save tab-he-glyphicon"></i>
          {{multiLanguage.downloadDetailExcel}}
        </jsonExcel>

        <multi-sheet-excel
          :ajaxGetKey="multiExcelAjax.getKey"
          :ajaxPar="multiExcelAjax.ajaxPar || false"
          :ajaxType="multiExcelAjax.ajaxType"
          :ajaxUrl="multiExcelAjax.url || false"
          :dataTh="multiExcelAjax.dataTh"
          :downloadName="multiLanguage.downloadName"
          :firstTh="firstTh"
          :rID="multiExcelAjax.rID"
          :secondTh="secondTh"
          :sheetName="multiLanguage.sheetName"
          class="btn btn-default"
          v-if="multiExcelAjax"
        >
          <i class="glyphicon glyphicon-save tab-he-glyphicon"></i>
          {{multiLanguage.downloadDetailExcel}}
        </multi-sheet-excel>
        <multi-sheet-excel
          :ajaxGetKey="multiExcelAjax.getKey"
          :ajaxPar="multiExcelAjax.ajaxPar || false"
          :ajaxType="multiExcelAjax.ajaxType"
          :ajaxUrl="multiExcelAjax.url || false"
          :dataTh="multiExcelAjax.dataTh"
          :downloadName="multiExcelAjax.filter.filterDownloadName"
          :filter="multiExcelAjax.filter"
          :firstTh="firstTh"
          :rID="multiExcelAjax.rID"
          :secondTh="secondTh"
          :sheetName="multiLanguage.sheetName"
          class="btn btn-default"
          v-if="multiExcelAjax.filter"
        >
          <i class="glyphicon glyphicon-save tab-he-glyphicon"></i>
          {{multiExcelAjax.filter.btnName}}
        </multi-sheet-excel>

        <router-link
          :class="{'radius-r': !handle.delete}"
          :to="handle.link"
          class="btn btn-default"
          v-if="handle && handle.link === 'accountDatum'"
        >
          <i class="glyphicon glyphicon-new-window tab-he-glyphicon"></i>
          {{multiLanguage.addAccount}}
        </router-link>
        <div
          :class="{'radius-r':handle.delete}"
          @click="deleteCol.switch = true"
          class="btn btn-default btn-danger mtable-tool-delete"
          v-show="handle.delete && !deleteCol.switch"
        >
          <i class="glyphicon glyphicon-trash tab-he-glyphicon"></i>
          {{multiLanguage.deletedData}}
        </div>
        <div
          :class="{'radius-r':handle.delete}"
          @click="deleteColNotarizeFn"
          class="btn btn-default btn-danger mtable-tool-delete"
          v-show="handle.delete && deleteCol.switch"
        >
          <i class="glyphicon glyphicon-log-out tab-he-glyphicon"></i>
          {{multiLanguage.confirmDelete}}
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <!-- </div> -->
    <div class="datatable-scroll" style="overflow: auto;">
      <slot name="datatable-scroll"></slot>
      <slot name="title-name"></slot>
      <div v-if="Array.isArray(trData[0])">
        <table
          aria-describedby="DataTables_Table_2_info"
          class="table table-striped table-bordered table-hover datatable-highlight dataTable no-footer"
          id="DataTables_Table_2"
          role="grid"
        >
          <thead>
            <tr role="row">
              <th v-if="operate.checkbox"></th>
              <th
                :class="{sorting: item.sort}"
                @click="sortFn(item.key,item.sort)"
                v-for="(item,index) in thData"
                v-if="item.flag === undefined ? true: item.flag"
              >{{item.name}}</th>
              <th tabindex="0" v-if="handle">{{multiLanguage.th.operation}}</th>
            </tr>
          </thead>
          <tbody :class="{'deleteCol-opt': handle.delete}" v-for="(trArr,under) in trData">
            <tr
              :class="trCls && trCls(item, index)"
              @click="clickColFn(item, index)"
              role="row"
              v-for="(item,index) in trArr"
              v-show="trArr.length > 0"
            >
              <td v-if="operate.checkbox">
                <input
                  @change="updateCheckArr(item)"
                  type="checkbox"
                  v-if="[3,4].indexOf(+item.STATUS) == -1"
                />
              </td>
              <td
                :class="{'pointer': deleteCol.switch}"
                class="sorting_1"
                v-for="obj in thData"
                v-if="obj.flag === undefined ? true: obj.flag"
              >
                <a
                  @click="linkDetails(item)"
                  v-if="link && link.key.indexOf(obj.key) > -1"
                >{{item[obj.key]}}</a>
                <span v-else>{{item[obj.key]}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <table
          aria-describedby="DataTables_Table_2_info"
          class="table table-striped table-bordered table-hover datatable-highlight dataTable no-footer"
          id="DataTables_Table_2"
          role="grid"
        >
          <thead>
            <tr role="row">
              <th v-if="operate.checkbox">
                <el-checkbox
                  :indeterminate="isIndeterminate"
                  @change="checkAll"
                  v-if="selectData.length !== 0"
                  v-model="selectAll"
                ></el-checkbox>
              </th>
              <th
                :class="{sorting: item.sort}"
                @click="sortFn(item.key,item.sort)"
                v-for="(item,index) in thData"
                v-if="item.flag === undefined ? true: item.flag"
              >{{item.name}}</th>
              <th tabindex="0" v-if="handle">{{multiLanguage.th.operation}}</th>
            </tr>
          </thead>
          <tbody :class="{'deleteCol-opt': handle.delete}">
            <tr
              :class="trCls && trCls(item, index)"
              @click="clickColFn(item, index)"
              role="row"
              v-for="(item,index) in trData"
              v-show="trData.length > 0"
            >
              <td v-if="operate.checkbox">
                <el-checkbox
                  @change="updateCheckArr(item)"
                  v-if="[3,4].indexOf(+item.STATUS) == -1"
                  v-model="item.checked"
                ></el-checkbox>
                <!-- <input type="checkbox" v-if="[3,4].indexOf(+item.STATUS) == -1" v-model="item.checked" @change="updateCheckArr(item)"> -->
              </td>
              <td
                :class="{'pointer': deleteCol.switch}"
                @click="deletePitch(item)"
                class="sorting_1"
                v-for="obj in thData"
                v-if="obj.flag === undefined ? true: obj.flag"
              >
                <a
                  @click="linkDetails(item)"
                  v-if="link && link.key.indexOf(obj.key) > -1"
                >{{item[obj.key]}}</a>
                <span v-else-if="tip && tip.key.indexOf(obj.key) > -1">
                  <el-tooltip>
                    <div slot="content">
                      <span v-for="(tips,value) in JSON.parse(item[obj.key])">
                        {{value}}&nbsp;&nbsp;:&nbsp;&nbsp;{{tips}}
                        <br />
                      </span>
                    </div>
                    <span
                      v-if="item[obj.key] && item[obj.key].length > 40"
                    >{{item[obj.key].substr(0, 40) + '...'}}</span>
                    <span v-else>{{item[obj.key]}}</span>
                  </el-tooltip>
                </span>
                <span v-else>{{item[obj.key]}}</span>
              </td>
              <td
                :class="{'pointer': deleteCol.switch}"
                @click="linkRegister(item)"
                class="text-center pointer"
                v-if="handle"
              >
                <i class="icon-compose" v-show="!deleteCol.switch"></i>
                <i
                  class="glyphicon glyphicon-ok color-red"
                  v-show="deleteCol.switch && deleteCol.list.indexOf(item[handle.idKey]) != -1"
                ></i>
                <i
                  class="glyphicon glyphicon-trash tab-he-glyphicon"
                  v-show="deleteCol.switch && deleteCol.list.indexOf(item[handle.idKey]) == -1"
                ></i>
              </td>
            </tr>
            <tr v-if="trData.length > 0 && Object.keys(totalTr).length > 0">
              <td v-for="item in totalTr">{{item}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <noData :fontSize="'18'" :text="multiLanguage.nodata" v-if="trData.length==0"></noData>
    </div>
    <div class="datatable-footer" v-if="selPage">
      <div
        aria-live="polite"
        class="dataTables_info"
        id="DataTables_Table_2_info"
        role="status"
      >{{multiLanguage.clauses}}{{multiLanguage.amount}}:&nbsp;{{page.pageLeng}}&nbsp;&nbsp;{{multiLanguage.present}}:&nbsp;{{page.active*selPage.limit-selPage.limit+1}}-{{Math.min(page.active*selPage.limit,page.pageLeng)}}</div>
      <div
        class="dataTables_paginate paging_simple_numbers"
        id="DataTables_Table_2_paginate"
        v-if="Math.ceil(page.pageLeng/selPage.list[selPage.active])"
      >
        <pagination
          :boundary-links="true"
          :direction-links="true"
          :max-size="page.pagenum"
          :total-page="Math.ceil(page.pageLeng/selPage.list[selPage.active])"
          @change="callpageFn"
          v-model="page.active"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import seek from 'components/seek'
import selPage from 'components/selPage'
import seekDatePicker from 'components/seekDatePicker'
import noData from 'components/noData'
import fileUpload from 'vue-upload-component'
import { Dropdown, Pagination } from 'uiv'
import jsonExcel from './excel'
import multiSheetExcel from './multiSheetExcel'
import { mapMutations } from 'vuex'

export default {
  props: {
    thData: {
      // 表格th数据
      type: Array,
      default: []
    },
    firstTh: {
      type: Object,
      default: () => {}
    },
    secondTh: {
      type: Object,
      default: () => {}
    },
    detailTh: {
      type: Array,
      default: () => []
    },
    trData: {
      type: Array,
      default: () => []
    }, // 表格tr数据
    totalData: {
      default: false
    },
    operate: {
      default: false
    },
    link: {
      default: false
    },
    tip: {
      default: false
    },
    handle: {
      default: false
    },
    multiLanguage: {
      // 翻译，也是文字型数据
      type: Object,
      default: {}
    },
    selPage: {
      // 显示条目数
      default: false
    },
    seekDropdown: {
      // 搜索目标选项
      default: false
    },
    page: {
      // 分页
      default: false
    },
    jsonExcelAjax: {
      // 下载Excel
      default: false
    },
    name: {
      default: ''
    },
    detailName: {
      defalut: ''
    },
    detailExcelAjax: {
      default: false
    },
    multiExcelAjax: {
      default: false
    },
    sort: {
      // 排序
      default: false
    },
    seekDatePicker: {
      // 时间搜索
      default: false
    },
    trCls: {
      // tr class
      default: false
    },
    back: {
      type: String,
      default: () => ''
    },
    downLoadTran: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      //pageactive: this.page ? this.page.active : "",
      seekDropdownProps: this.seekDropdown ? this.seekDropdown : '',
      deleteCol: {
        // 删除功能
        switch: false,
        list: []
      },
      totalTr: {},
      checkedArr: [],
      refuseReason: '',
      isIndeterminate: false,
      selectAll: false,
      trSize: 0,
      selectData: []
    }
  },
  mounted() {
    this.totalData && this.total()
    if (this.selPage && !this.selPage.active) this.$parent.selPage.active = 0
  },
  computed: {
    trDataKeys() {
      return Object.keys(this.trData[0])
    }
  },
  methods: {
    updateStatus(value) {
      if (window.confirm(this.multiLanguage.commit)) {
        let ajaxObj = {}
        let name = JSON.parse(sessionStorage.getItem('user')).user_name
        if (value == '3') {
          ajaxObj = { type: value, level: this.operate.level, data: this.checkedArr, update_by: name }
        } else {
          ajaxObj = { type: value, level: this.operate.level, reject_reason: this.refuseReason, data: this.checkedArr, update_by: name }
        }
        this.refuseReason = ''
        this.checkedArr = []
        this.$http.post(this.operate.url, ajaxObj).then(res => {
          this.$emit('tableChange')
        })
      } else {
        return false
      }
    },
    checkAll(val) {
      this.checkedArr = val ? this.selectData.slice() : []
      for (let v of this.trData) {
        if (v.STATUS !== undefined && [0, 1, 2].indexOf(+v.STATUS) > -1) v.checked = val
      }
      //console.log(this.checkedArr.length)
      this.isIndeterminate = false
    },
    updateCheckArr(checkObj) {
      //console.log(this.checkedArr.indexOf(checkObj) > -1)
      if (this.checkedArr.indexOf(checkObj) > -1) this.checkedArr.splice(this.checkedArr.indexOf(checkObj), 1)
      else this.checkedArr.push(checkObj)
      //console.log(this.trSize)
      this.selectAll = this.checkedArr.length === this.trSize
      this.isIndeterminate = this.checkedArr.length > 0 && this.checkedArr.length < this.trSize
      //console.log(this.checkedArr)
    },
    total() {
      if (!this.totalData || !this.totalData.length) return
      let keys = Object.keys(this.totalData[0])
      let obj = {}
      this.totalData.forEach(item => {
        keys.forEach((key, keyIndex) => {
          if (Object.prototype.toString.call(item[key]) === '[object Number]' && keyIndex !== 0) {
            if (!obj[key] && obj[key] !== 0) obj[key] = 0
            obj[key] += item[key]
          } else if (Object.prototype.toString.call(item[key]) === '[object String]') {
            obj[key] = '#'
          } else if (keyIndex === 0) {
            obj[key] = this.multiLanguage.total
          }
        })
      })
      Object.keys(obj).forEach(key => {
        if (Object.prototype.toString.call(obj[key]) === '[object Number]') {
          obj[key] = +obj[key].toFixed(2)
        }
      })
      this.totalTr = obj
    },
    sortFn(key, flag) {
      if (!this.sort || !flag) return
      this.sort.key = key
      if (this.sort.method === 'ASC') this.$parent.sort.method = 'DESC'
      else if (this.sort.method === 'DESC') this.$parent.sort.method = 'ASC'
      this.$emit('tableChange')
    },
    clickSeekDropdown(index) {
      this.$emit('clickSeekDropdown', index)
    },
    selPageFn(index, item) {
      this.SAVEPAGEMAXINDEX(index)
      this.$parent.selPage.active = index
      this.$parent.selPage.limit = this.selPage.list[this.selPage.active]
      this.$parent.page.offset = 0
      this.pageactive = 1
      this.$parent.page.active = 1
      this.$emit('tableChange')
    },
    callpageFn(index) {
      this.$parent.page.active = index
      this.$parent.page.offset = this.selPage ? (this.page.active - 1) * this.selPage.list[this.selPage.active] : ''
      this.$emit('tableChange')
    },
    setSeekDropdown(index) {
      this.seekDropdownActive = index
    },
    seek(seekStr) {
      this.pageactive = 1
      if (this.page) this.$parent.page.offset = 0
      if (this.$parent.page) this.$parent.page.active = 1
      this.$emit('seek')
    },
    seekDatePickerFn(seekVal) {
      this.$emit('seek')
    },
    clickColFn(colItem, index) {
      this.$emit('clickCol', colItem, index)
    },
    deleteColClick() {
      this.deleteCol.switch = true
    },
    deleteColNotarizeFn() {
      this.deleteCol.switch = false
      this.$emit('deleteList', this.deleteCol.list)
      this.deleteCol.list = []
    },
    deletePitch(item) {
      if (this.deleteCol.switch === false) {
        return
      }
      let id = item[this.handle.idKey]
      let index = this.deleteCol.list.indexOf(id)
      if (index === -1) {
        this.deleteCol.list.push(id)
      } else {
        this.deleteCol.list.splice(index, 1)
      }
    },
    linkDetails(item) {
      if (this.back !== '') {
        sessionStorage.setItem('back', this.back)
      }
      this.$router.push({
        path: this.link.path,
        query: item
      })
    },
    linkRegister(item) {
      if (this.deleteCol.switch === true) {
        this.deletePitch(item)
      } else {
        this.$router.push({
          path: this.handle.link,
          query: {
            id: item[this.handle.idKey]
          }
        })
      }
    },
    ...mapMutations(['SAVEPAGEMAXINDEX'])
  },
  watch: {
    trData(newVal, oldVal) {
      this.selectAll = false
      this.isIndeterminate = false
      this.trSize = 0
      this.selectData = []
      if (this.operate) {
        for (let v of newVal) {
          if (v.STATUS !== undefined && [0, 1, 2].indexOf(+v.STATUS) > -1) {
            this.trSize++
            this.selectData.push(v)
          }
        }
      }
    },
    seekDropdownActive(curVal, oldVal) {
      this.$parent.seekData.seekDropdownActive = curVal
    },
    totalData(curVal, oldVal) {
      curVal.length > 0 && this.total()
    }
  },
  components: {
    seek,
    selPage,
    seekDatePicker,
    fileUpload,
    Dropdown,
    Pagination,
    jsonExcel,
    //detailExcel,
    multiSheetExcel,
    noData
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.commission-confirm {
  float: left;
  margin-right: 10px;
}
.mtable {
  .datatable-scroll {
    .table {
      thead {
        border-top: 1px solid #ddd;
        tr {
          background-color: #ebedf7;
        }
      }
    }
  }
  .mtable-tool {
    padding: 0 20px 25px;
    border-bottom: 0;
    .mtable-tool-seek,
    .mtable-tool-selPage,
    .mtable-tool-fn {
      padding-top: 20px;
      line-height: 36px;
    }
    .mtable-tool-fn {
      .radius-r {
        border-top-right-radius: 3px !important;
        border-bottom-right-radius: 3px !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// mytable.vue?60c45aec